import React from "react"
import "./index.css"

// English | Math | Science, etc.
enum Category {
    English,
    Math,
    Reading,
    Science,
    Writing,
    SATVocab,
}

interface Props {
    category: Category 
}

const CATEGORICAL_COLOR_MAP = {
    English: "purple",
    Math:    "blue",
    Reading: "orange",
    Science: "green",
    Writing: "pink",
    SATVocab: "orange",
}

export default function CategoryRibbon(props) {
    let {category} = props  
    let color = CATEGORICAL_COLOR_MAP[category] || "blue"
    let categoryKey = category.toLowerCase()
    let title = category === "SATVocab" ? "SAT Vocab": category

    return (
        <div className="category-ribbon-container">
            <span className={`ribbon ${color}`}>
                <img alt="" src={`/assets/images/icons/subjects/ico-subject-${categoryKey}.svg`} width="28" height="27" />
            </span>
            <h3 className="category-ribbon-title">{title}</h3>
        </div>
    )
}
